import { render, staticRenderFns } from "./NewCleaningReportPage.vue?vue&type=template&id=2888fcc8&scoped=true"
import script from "./NewCleaningReportPage.vue?vue&type=script&lang=js"
export * from "./NewCleaningReportPage.vue?vue&type=script&lang=js"
import style0 from "./NewCleaningReportPage.vue?vue&type=style&index=0&id=2888fcc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888fcc8",
  null
  
)

export default component.exports